import { Label, mergeStyles, Stack } from '@fluentui/react';

import { FormVariables } from '../slice/newFormReducers';
import { BorderedStack, Item } from './utils';

export default (props: { formVariables: FormVariables }) => {
  return (
    <BorderedStack className="ignore-defaults">
      <Item grow style={{ padding: "0 4px" }}>
        <Stack horizontalAlign="center">
          <Label className={fontStyles}>
            <u>Sözleşme Şartları</u>
          </Label>
        </Stack>
        <ul
          style={{
            margin: "0",
            padding: "0 0.5cm",
            fontSize: "10px",
          }}
        >
          <li>
            İşbu sözleşme konusu, ALICI ile SATICI arasında alıcı tarafından
            özelliklerinin belirlenmesi suretiyle ilgili tarafların hak ve
            yükümlülüklerinin saptanmasıdır.
          </li>
          <li>
            ALICI'nın özel istek ve talepleri uyarınca üretilen ve/veya üzerinde
            değişiklik ya da ilaveler yapılarak kişiye özel hale getirilen
            ürünler, örneğin; kesme, delme, kullanıcı isteğine göre özel renkte
            üretilmiş ürünler için cayma hakkı kullanılamaz.
          </li>
          {props.formVariables.isSpecialOrder && (
            <li>
              Özel sipariş verildikten sonra iptali ve iadesi talep edilemez.
            </li>
          )}
          <li>Sipariş ödemesinin tamamı yapılmadan ürün sevkiyatı yapılmaz.</li>
          <li>
            Kaporalı satışlarda ürün ödemesinin tamamı 15 gün içerisinde
            yapılmalıdır.
          </li>
          <li>
            Ev tekstili ürünlerinde örneğin, yatak, yastık, yorgan ambalajı
            açıldıktan sonra hijyen nedeniyle değişim veya iade yapılamaz.
          </li>
          <li>
            Ürünlerin sevk ve kurulum esnasında meydana gelebilecek arıza ve her
            türlü sorunu yerinde tespit edildikten sonra, arızalı parça veya
            parçaların, temin veya üretim süreci sonunda, satıcı tarafından hiç
            bir ücret talep etmeksizin servis hizmeti verilecektir ya da onarımı
            yapılacaktır.
          </li>
          <li>
            Müşteri keyfi olarak ürünü teslim almaktan vazgeçmesi halinde
            kendisinden ürün satış bedelinin %15 oranında cayma cezai şart
            bedeli kesilecektir.
          </li>
          <li>Satış şartları müşteri tarafından okunarak imzalanmıştır.</li>
        </ul>
        <Stack horizontal horizontalAlign="center">
          <Stack horizontalAlign="center" style={{ width: "40%" }}>
            <Label className={fontStyles}>Siparişi Alan</Label>
            <span className={fontStyles}>
              {props.formVariables.employee?.name}
            </span>
          </Stack>
          <Stack horizontalAlign="center" style={{ width: "40%" }}>
            <Label className={fontStyles}>Siparişi Veren</Label>
          </Stack>
        </Stack>
        <br />
      </Item>
    </BorderedStack>
  );
};

const fontStyles = mergeStyles({ fontSize: "10px" });
